import { gql } from '@apollo/client';

export const GET_YEARLY_ENVIRONMENTAL_STATISTICS = gql`
  query getYearlyEnvironmentalStatistics($year: Int!) {
    getYearlyEnvironmentalStatistics(year: $year) {
      directEmissions
      indirectEmissions
      emissionIntensity
      waterConsumption {
        Emission
        Facility {
          id
          name
        }
      }
      totalEnergyConsumption
      energyIntensity
      facilityYearlyEmission {
        indirectEmissions
        directEmissions
        facility {
          id
          name
        }
      }
      energyConsumptionByType {
        biogas
        biomass
        coal
        geothermal
        heatingOil
        hydroelectric
        hydrogen
        purchasedElectricity
        purchasedHeating
        solar
        wasteHeatRecovery
        wind
        woodChips
        woodPellets
        naturalGasConsumption
      }
      energyConsumptionByFacility {
        facility {
          id
          name
        }
        totalEnergyConsumption
      }
      wasteGenerationByFacility {
        facility {
          id
          name
        }
        wasteGeneration
      }
    }
  }
`;

export const GET_YEARLY_SOCIAL_STATISTICS = gql`
  query getYearlySocialStatistics($year: Int!) {
    getYearlySocialStatistics(year: $year) {
      employeeTurnoverRate
      numberOccupationalAccidents
      percentageFemaleEmployees
      totalFemaleManagerEmployees
      totalFemaleNonManagerEmployees
      totalMaleManagerEmployees
      totalMaleNonManagerEmployees
      totalNumberOfEmployees
      totalNumberOfEmployees30To50
      totalNumberOfEmployeesOver50
      totalNumberOfEmployeesUnder30
      trainingHoursPerEmployee
      facilityGenders {
        facility {
          id
          name
        }
        femaleEmployees
        maleEmployees
      }
    }
  }
`;

export const GET_NEXT_CALCULATION_TIME = gql`
  query GetNextCalculationTime {
    getNextCalculationTime
  }
`;

export const GET_ESG_VALUES_AGG_BY_REPORT_SECTION = gql`
  query esgValuesAggByReportSection($reportSectionId: ID!, $year: Int!) {
    esgValuesAggByReportSection(reportSectionId: $reportSectionId, year: $year) {
      kpi {
        title
        type
      }
      selectedUnit
      value
    }
    emissionsByReportSection(reportSectionId: $reportSectionId, year: $year) {
      title
      selectedUnit
      value
    }
  }
`;

export const GET_DATA_MANAGEMENT_OVERVIEW_STATS = gql`
  query DataManagementOverviewStats($year: Int!) {
    numberRequestedEsgValues(year: $year)
    openDataRequests(year: $year) {
      category {
        id
        title
        area
      }
      facility {
        id
        city
      }
      collectOverviewId
      status
      requestedBy {
        lastName
        firstName
        email
      }
      year
    }
    getYearlyGeneralStatistics(year: $year) {
      overallEsgProgress
      numberOfCompletedEsgValues
      esgProgressByCategory {
        progress
        category {
          title
          id
          area
        }
      }
      completedFacilities {
        completedFacilities
        totalFacilities
      }
      esgProgressByFacility {
        facilityId
        facilityName
        environment
        social
        governance
      }
    }
  }
`;

export const GET_ROADMAP_STATS = gql`
  query GetRoadmapStatistics($year: Int!) {
    getRoadmapStatistics(year: $year) {
      materialityAssessmentProgress
      dataCollectionProgress
      reportWritingProgress
      reportIdForRedirect
    }
  }
`;

export const GET_YEARLY_GOVERNANCE_STATISTICS = gql`
  query GetYearlyGovernanceStatistics($year: Int!, $useGlobal: Boolean) {
    getYearlyGovernanceStatistics(year: $year, useGlobal: $useGlobal) {
      numberOfMembersInManagementAndSupervisoryBoards
      numberOfFemaleMembersInManagementAndSupervisoryBoards
      totalMonetaryValuePoliticalContributions
      numberConfirmedCasesCorruption
    }
  }
`;
